// extracted by mini-css-extract-plugin
export default {"error_container":"Error400_error_container__YIV7Z","logo":"Error400_logo__ZDDq8","title":"Error400_title__BCjGV","sub_title":"Error400_sub_title__mxpei","btn":"Error400_btn__Pw5Hr"};